import {
  categoryListSchema,
  type CategoryList,
  type ListCategoriesQuery,
} from '@klopotun/contracts';
import { apiRequest } from '../../../../shared/api/index.js';

const searchOf = (query: ListCategoriesQuery): string =>
  `?${new URLSearchParams({ includeArchived: String(query.includeArchived) }).toString()}`;

const fetchCategories = (query: ListCategoriesQuery, signal: AbortSignal): Promise<unknown> =>
  apiRequest<unknown>(`/categories${searchOf(query)}`, { signal });

export const getCategories = async (
  query: ListCategoriesQuery,
  signal: AbortSignal,
): Promise<CategoryList> => categoryListSchema.parse(await fetchCategories(query, signal));
